import React, {PropTypes as T} from 'react';
import Modal, {ModalContent, ModalFooter} from '../../common/modal';
import ErrorHeader from '../../common/modal/icon_error_header';
import Button from '../../common/button';
import TU from '../../common/tu';
import withDevice from '../../common/withDeviceHOC';
import SadTicketIcon from '../../common/icons/icon_sad_ticket';
import Cookies from 'js-cookie';
import BasketActions from '../../../actions/basket';

export class SeatmapLoadErrorModal extends React.Component {
  static propTypes = {
    eventId: T.string,
    error: T.object,
    isMobile: T.bool
  };

  tryAgain = () => {
    window.location.reload();
  };

  goToBestAvailable = () => {
    Cookies.set(`EDP_TYPE_${this.props.eventId}`, 'CLASSIC');
    BasketActions.goToBestAvailable(this.props.eventId);
  };

  render () {
    const trans = this.props.error.translations;
    return (
      <Modal dataComponent="seatmap-loaderror-modal" isOpen>
        <ErrorHeader title={trans.SEATMAP_LOAD_ERROR_HEADER} />
        <ModalContent>
          <SadTicketIcon className="modal__sad_ticket_icon" />
          <TU text={trans.SEATMAP_LOAD_ERROR_TEXT} />
        </ModalContent>
        <ModalFooter>
          <Button
            data-component="best-available-button"
            primary
            onClick={this.goToBestAvailable}
            flex={this.props.isMobile}
            outlined>{trans.FIND_BEST_AVAILABLE_BUTTON}</Button>
          <Button
            data-component="try-again-button"
            primary
            onClick={this.tryAgain}
            flex={this.props.isMobile}>{trans.TRY_AGAIN_BUTTON}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withDevice(SeatmapLoadErrorModal);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/errors/seatmap_load_error.js